import * as t from "io-ts";
import { MaybeExportedTreeV, Tree } from "./tree";

export const DocumentMetaV = t.exact(
  t.type({
    postType: t.string,
    typeLabel: t.string,
    titleLabel: t.string,
    id: t.number,
    // Only available for templates
    templateSettingsType: t.union([t.literal(false), t.string])
  })
);

export const DocumentMetasV = t.array(DocumentMetaV);

export type DocumentMeta = t.TypeOf<typeof DocumentMetaV>;

export const BreakdanceDocumentWithExportedTreeV = t.type({
  tree: MaybeExportedTreeV,
  documentMeta: DocumentMetaV
});

export type BreakdanceDocumentWithExportedTree = t.TypeOf<
  typeof BreakdanceDocumentWithExportedTreeV
>;

export type BreakdanceDocument = {
  documentMeta: DocumentMeta;
  tree: Tree;
};
